export const POSITIONS = ['Офіціант', 'Кухар', 'Прибиральник', 'Бармен', 'Менеджер',
  'Бариста']
